import { render, staticRenderFns } from "./departmentMember.vue?vue&type=template&id=b1f05896&"
import script from "./departmentMember.vue?vue&type=script&lang=js&"
export * from "./departmentMember.vue?vue&type=script&lang=js&"
import style0 from "./departmentMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports